import { gql } from "@apollo/client";

export const FIND_ALL_RESPONSE_PLANS_BY_PLAN = gql`
  query FindAllResponsePlansByPlan($uuid: ID!) {
    findAll: findAllResponsePlansByPlan(uuid: $uuid) {
      email
      phone
      planOwnerfirstName
      planOwnerlastName
      thread
      uuid
    }
  }
`;

export const CREATE_RESPONSE_PLAN = gql`
  mutation CreateResponsePlan($data: CreateResponsePlanInput!) {
    createResponsePlan(data: $data) {
      email
      phone
      planOwnerfirstName
      planOwnerlastName
      thread
      uuid
    }
  }
`;

export const UPDATE_RESPONSE_PLAN = gql`
  mutation UpdateResponsePlan($data: UpdateResponsePlanInput!) {
    updateResponsePlan(data: $data) {
      email
      phone
      planOwnerfirstName
      planOwnerlastName
      thread
      uuid
    }
  }
`;

export const DELETE_RESPONSE_PLAN = gql`
  mutation DeleteResponsePlan($uuid: ID!) {
    deleteResponsePlan(uuid: $uuid) {
      email
      phone
      planOwnerfirstName
      planOwnerlastName
      thread
      uuid
    }
  }
`;